module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-07-ddc8be14c276fbd178f710bcbcffc579.jpg";